//map greek to latin
const latinMap = {
    'α': 'a', 'β': 'v', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'i', 'θ': 'th',
    'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': 'x', 'ο': 'o', 'π': 'p',
    'ρ': 'r', 'σ': 's', 'ς': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'ch', 'ψ': 'ps',
    'ω': 'o', 'ά': 'a', 'έ': 'e', 'ή': 'i', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ώ': 'o',
    'Α': 'A', 'Β': 'V', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'I', 'Θ': 'Th',
    'Ι': 'I', 'Κ': 'K', 'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': 'X', 'Ο': 'O', 'Π': 'P',
    'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y', 'Φ': 'F', 'Χ': 'Ch', 'Ψ': 'Ps', 'Ω': 'O'
};
//map latin to greek
const greekMap = {
    'a': 'α', 'b': 'μπ', 'c': 'κ', 'd': 'δ', 'e': 'ε', 'f': 'φ', 'g': 'γ', 'h': 'χ',
    'i': 'ι', 'j': 'τζ', 'k': 'κ', 'l': 'λ', 'm': 'μ', 'n': 'ν', 'o': 'ο', 'p': 'π',
    'r': 'ρ', 's': 'σ', 't': 'τ', 'u': 'υ', 'v': 'β', 'w': 'ω', 'x': 'ξ', 'y': 'υ', 'z': 'ζ',
    'A': 'Α', 'B': 'Μπ', 'C': 'Κ', 'D': 'Δ', 'E': 'Ε', 'F': 'Φ', 'G': 'Γ', 'H': 'Χ',
    'I': 'Ι', 'J': 'Τζ', 'K': 'Κ', 'L': 'Λ', 'M': 'Μ', 'N': 'Ν', 'O': 'Ο', 'P': 'Π',
    'R': 'Ρ', 'S': 'Σ', 'T': 'Τ', 'U': 'Υ', 'V': 'Β', 'W': 'Ω', 'X': 'Ξ', 'Y': 'Υ', 'Z': 'Ζ'
};

export const toLatin = (text) => {
    if (!text) return "";
    return text.split('').map(char => latinMap[char] || char).join('');
};

//rules before we implement greekMap
export const toGreek = (text) => {
    if (!text) return "";
    let converted = text
        .replace(/th/g, 'θ').replace(/Th/g, 'Θ').replace(/TH/g, 'Θ')
        .replace(/ch/g, 'χ').replace(/Ch/g, 'Χ').replace(/CH/g, 'Χ')
        .replace(/ps/g, 'ψ').replace(/Ps/g, 'Ψ').replace(/PS/g, 'Ψ')
        .replace(/ph/g, 'φ').replace(/Ph/g, 'Φ').replace(/PH/g, 'Φ');

    converted = converted.split('').map(char => greekMap[char] || char).join('');
    
    // Apply final sigma rule: σ at the end of a word becomes ς
    converted = converted
        .split(' ')
        .map(word => {
            // Replace σ with ς only if it's at the end of the word
            if (word.endsWith('σ')) {
                return word.slice(0, -1) + 'ς';
            }
            return word;
        })
        .join(' ');
    
    return converted;
};

//capitalize the 1st letter of every word
export const capitalize = (str) => {
    if (!str) return "";
    return str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

//Store brand exceptions
export const brandExceptions = {
    //SUPERMARKETS
    "my market": "My Market",
    "lidl": "Lidl",
    "ab": "ΑΒ",
    "ab vassilopoulos": "ΑΒ Βασιλόπουλος",
    "a.b.": "ΑΒ",
    "market in": "Market In",
    "ok market": "OK Market",
    "ok! market": "OK! Market",
    "bazaar": "Bazaar",
    "the mart": "The Mart",
    "masoutis": "Μασούτης",
    "sklavenitis": "Σκλαβενίτης",
    "kritikos": "Κρητικός",
    "galaxias": "Γαλαξίας",
    "synka": "ΣΥΝ.ΚΑ",
    "pente": "Πέντε",
    "halkiadakis": "Χαλκιαδάκης",

    // CONVENIENCE STORES & ΜΙNI ΜΑΡΚΕΤ
    "kiosky's": "Kiosky's",
    "kioskys": "Kiosky's",
    "4all": "4all",
    "today's": "Today's",
    "todays": "Today's",
    "today stores": "Today Stores",
    "yes stores": "Yes Stores",
    "seven spots": "Seven Spots",
    "smile markets": "Smile Markets",
};

export const smartToGreek = (text) => {
    if (!text) return "";
    
    const lowerText = text.toLowerCase().trim();
    
    //if found in the exeptions return it exactly as in the list
    if (brandExceptions[lowerText]) {
        return brandExceptions[lowerText]; 
    }

    const greek = toGreek(text);
    return capitalize(greek);
};

export const cityExceptions = {
    // ATTICA & CENTRAL GREECE
    "athens": "Αθήνα",
    "athina": "Αθήνα",
    "athenai": "Αθήνα",

    "center": "Κέντρο",
    "center athens": "Κέντρο Αθήνας",
    "syntagma": "Συντάγμα",
    "plaka": "Πλάκα",
    "psyrri": "Ψυρρή",
    "psiri": "Ψυρρή",
    "exarchia": "Εξάρχεια",
    "marousi": "Μαρούσι",
    "glyfada": "Γλυφάδα",
    "vouliagmeni": "Βουλιάγμενη",
    "kalamaki": "Καλαμάκι",

    // THESSALY
    "larissa": "Λάρισα",
    "larisa": "Λάρισα",
    "larissa": "Λάρισα",

    "volos": "Βόλος",
    "volos": "Βόλος",

    "trikala": "Τρίκαλα",
    "trikale": "Τρίκαλα",

    "lamia": "Λάμια",

    "agios ioannis": "Άγιος Ιωάννης",

    // THESSALY & NORTHERN
    "thessaloniki": "Θεσσαλονίκη",
    "thessaloniki": "Θεσσαλονίκη",
    "salonica": "Θεσσαλονίκη",
    "salonika": "Θεσσαλονίκη",

    "giannitsa": "Γιαννίτσα",
    "giannitza": "Γιαννίτσα",

    "katerini": "Κατερίνη",

    "pieria": "Πιερία",

    // PELOPONNESE
    "patra": "Πάτρα",
    "patras": "Πάτρα",
    "patrae": "Πάτρα",

    "corinth": "Κόρινθος",
    "korinthos": "Κόρινθος",
    "korintos": "Κόρινθος",

    "nafplio": "Ναύπλιο",
    "navplio": "Ναύπλιο",
    "nauplia": "Ναύπλιο",

    "sparta": "Σπάρτη",
    "sparti": "Σπάρτη",

    "kalamata": "Καλάματα",
    "kalamae": "Καλάματα",

    "mycenae": "Μυκήναι",
    "mikines": "Μυκήναι",

    "delphi": "Δελφοί",
    "delfi": "Δελφοί",

    // CRETE
    "heraklion": "Ηράκλειο",
    "iraklio": "Ηράκλειο",
    "heraklio": "Ηράκλειο",
    "iraklion": "Ηράκλειο",
    "herakleon": "Ηράκλειο",

    "chania": "Χανιά",
    "hania": "Χανιά",
    "xania": "Χανιά",
    "canea": "Χανιά",

    "rethymno": "Ρέθυμνο",
    "rethimno": "Ρέθυμνο",
    "rethymnon": "Ρέθυμνο",

    "agios nikolaos": "Άγιος Νικόλαος",
    "lasithi": "Λασίθι",

    // DODECANESE
    "rhodes": "Ρόδος",
    "rodos": "Ρόδος",
    "rhodos": "Ρόδος",

    "kos": "Κώς",

    "kalymnos": "Κάλυμνος",
    "kalumnos": "Κάλυμνος",

    "patmos": "Πάτμος",

    "leros": "Λέρος",

    // CYCLADES
    "mykonos": "Μύκονος",
    "mykonoi": "Μύκονος",

    "santorini": "Σαντορίνη",
    "thira": "Σαντορίνη",
    "thera": "Σαντορίνη",

    "naxos": "Νάξος",

    "paros": "Πάρος",

    "antiparos": "Αντίπαρος",

    "tinos": "Τήνος",
    "tenos": "Τήνος",

    "syros": "Σύρος",
    "syra": "Σύρος",

    "delos": "Δήλος",

    "milos": "Μήλος",
    "melos": "Μήλος",

    "serifos": "Σέριφος",

    // NORTH AEGEAN
    "lesbos": "Λέσβος",
    "lesbio": "Λέσβος",
    "mytilene": "Μυτιλήνη",

    "chios": "Χίος",
    "hios": "Χίος",

    "samos": "Σάμος",

    "limnos": "Λήμνος",
    "limno": "Λήμνος",
    "lemnos": "Λήμνος",

    "skyros": "Σκύρος",

    "skiathos": "Σκιάθος",

    "skopelos": "Σκόπελος",

    // EASTERN THESSALY & NORTHERN
    "chalkida": "Χαλκίδα",
    "halkida": "Χαλκίδα",
    "xalkida": "Χαλκίδα",
    "chalcis": "Χαλκίδα",

    "volos": "Βόλος",

    // EPIRUS & WESTERN
    "ioannina": "Ιωάννινα",
    "giannena": "Ιωάννινα",
    "yannena": "Ιωάννινα",
    "jannina": "Ιωάννινα",
    "janina": "Ιωάννινα",

    "arta": "Άρτα",

    "preveza": "Παραμυθιά",

    "lefkada": "Λευκάδα",
    "leucada": "Λευκάδα",
    "lefkas": "Λευκάδα",

    "corfu": "Κέρκυρα",
    "kerkyra": "Κέρκυρα",
    "corfou": "Κέρκυρα",

    // IONIAN ISLANDS
    "zakynthos": "Ζάκυνθος",
    "zante": "Ζάκυνθος",
    "zacynthos": "Ζάκυνθος",

    "cephalonia": "Κεφαλονιά",
    "kefalonia": "Κεφαλονιά",
    "cephallenia": "Κεφαλονιά",

    "ithaca": "Ιθάκη",
    "ithaki": "Ιθάκη",

    // NORTHERN MAINLAND
    "kavala": "Καβάλα",

    "xanthi": "Ξάνθη",
    "xanta": "Ξάνθη",

    "komotini": "Κομοτινή",

    "serres": "Σέρρες",
    "seres": "Σέρρες",

    "kastoria": "Καστοριά",

    "florina": "Φλώρινα",
    "florinna": "Φλώρινα",

    "kilkis": "Κιλκίς",

    "kozani": "Κοζάνη",

    // THESSALY & SURROUNDING
    "agrinio": "Αγρίνιο",
    "agrinium": "Αγρίνιο",

    "messolonghi": "Μεσολόγγι",
    "missolonghi": "Μεσολόγγι",

    // PELOPONNESE ADDITIONS
    "argos": "Άργος",

    "tripoli": "Τρίπολη",
    "tripolis": "Τρίπολη",

    "tripolis": "Τρίπολη",

    "olympia": "Ολυμπία",

    "pyrgos": "Πύργος",

    // CENTRAL GREECE ADDITIONS
    "meteora": "Μετέωρα",

    "livadia": "Λιβάδια",
};  

export const smartCityToGreek = (text) => {
    if (!text) return "";
    const lowerText = text.toLowerCase().trim();

    if (cityExceptions[lowerText]) {
        return cityExceptions[lowerText];
    }
    return capitalize(toGreek(text));
};

export const areaExceptions = {
    // ATHENS NEIGHBORHOODS
    "city center": "Κέντρο",
    "center": "Κέντρο",
    "downtown": "Κέντρο",
    "syntagma": "Συντάγμα",
    "plaka": "Πλάκα",
    "placa": "Πλάκα",
    "psyrri": "Ψυρρή",
    "psiri": "Ψυρρή",
    "exarchia": "Εξάρχεια",
    "exarxeia": "Εξάρχεια",
    "marousi": "Μαρούσι",
    "maroussi": "Μαρούσι",
    "glyfada": "Γλυφάδα",
    "glyphada": "Γλυφάδα",
    "vouliagmeni": "Βουλιάγμενη",
    "voulagmeni": "Βουλιάγμενη",
    "kalamaki": "Καλαμάκι",
    "kalamakia": "Καλαμάκι",
    "pagrati": "Παγράτι",
    "varkiza": "Βαρκίζα",
    "varkeza": "Βαρκίζα",
    "hellinikon": "Ελληνικόν",
    "hellenikon": "Ελληνικόν",
    "alimos": "Άλιμος",
    "alypous": "Αλύπους",
    "dafni": "Δάφνη",
    "daphni": "Δάφνη",
    "kaisariani": "Καισαριανή",
    "kaisariani": "Καισαριανή",
    "vyronas": "Βύρωνας",
    "vyrone": "Βύρωνας",
    "zografou": "Ζωγράφου",
    "zografus": "Ζωγράφου",
    "peristeri": "Περιστέρι",
    "peristeri": "Περιστέρι",
    "egaleo": "Εγάλεω",
    "egalean": "Εγάλεω",
    "moschato": "Μοσχάτο",
    "moschaton": "Μοσχάτο",
    "ilioupoli": "Ηλιούπολη",
    "iliupoli": "Ηλιούπολη",
    "chalandri": "Χαλάνδρι",
    "chalandri": "Χαλάνδρι",
    "melissia": "Μελίσσια",
    "melicia": "Μελίσσια",
    "kifissia": "Κηφισιά",
    "kifisia": "Κηφισιά",
    "nea-ionia": "Νέα Ιωνία",
    "nea ionia": "Νέα Ιωνία",
    "galatsi": "Γαλάτσι",
    "galasti": "Γαλάτσι",
    "patisia": "Πατήσια",
    "patissia": "Πατήσια",
    "omonoia": "Ομόνοια",
    "omonoea": "Ομόνοια",
    "monastiraki": "Μοναστηράκι",
    "monastiraki": "Μοναστηράκι",
    "thisio": "Θησείο",
    "thisseio": "Θησείο",
    "gazi": "Γάζι",
    "metaxourgeio": "Μεταξουργείο",

    // COMMON AREA TERMS
    "center": "Κέντρο",
    "downtown": "Κέντρο",
    "suburban": "Περιφέρεια",
    "suburbs": "Περιφέρεια",
    "countryside": "Υπαίθρια",
    "near": "Κοντά",
    "railway": "Σταθμό",
    "station": "Σταθμό",
    "port": "Λιμάνι",
    "beach": "Παραλία",
    "mountain": "Βουνό",
    "valley": "Κοιλάδα",

    // THESSALONIKI NEIGHBORHOODS
    "ano liosia": "Άνω Λιόσια",
    "kato liosia": "Κάτω Λιόσια",
    "kordelio": "Κορδέλιο",
    "evosmos": "Εύοσμος",

    // GENERAL GREEK AREA TYPES
    "upper": "Άνω",
    "lower": "Κάτω",
    "new": "Νέα",
    "old": "Παλιά",
};

export const smartAreaToGreek = (text) => {
    if (!text) return "";
    const lowerText = text.toLowerCase().trim();

    if (areaExceptions[lowerText]) {
        return areaExceptions[lowerText];
    }
    return capitalize(toGreek(text));
};